import Vue from "vue";
import VueRouter from "vue-router";
import SideMenu from "../layouts/SideMenu";
import Login from "../views/Login";
import Logout from "../views/Logout";
import Register from "../views/Register";
import ErrorPage from "../views/ErrorPage";
import Terms from "../views/Terms";
import FileUpload from "../views/UserAria";
import AdminAria from "../views/AdminAria";
import Order from "../views/Order";
import Confirm from "../views/Confirm";
import Home from "../views/Home";
import ContactAs from "../views/ContactAs";
import StripeElements from "../views/StripeElements";
import OrderSuccess from "../views/OrderSuccess";
import ResetPassword from "../views/ResetPassword";
import ResetForm from "../views/ResetForm";
import FileSpecifiesUpload from "../views/FileSpecifiesUpload";
import Bionet from "../views/Bionet";
import VegetationBionet from "../views/VegetationBionet";
import FileBionetUpload from "../views/FileBionetUpload";
import PmstProfile from "../views/PmstProfile";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: SideMenu,
    children: [
      {
        path: "/",
        name: "home",
        component: Home
      },
      {
        path: "password-reset/:token",
        name: "reset",
        component: ResetPassword
      },
      {
        path: "reset-form",
        name: "resetForm",
        component: ResetForm
      },
      {
        path: "pmstprofile",
        name: "pmstProfile",
        component: PmstProfile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "bionet/upload",
        name: "bionet_upload",
        component: FileBionetUpload,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "specifies/upload",
        name: "specifies",
        component: FileSpecifiesUpload,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "success",
        name: "success",
        component: OrderSuccess,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "confirm/:fileId",
        name: "confirm",
        component: Confirm,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "contact-as",
        name: "contactas",
        component: ContactAs
      },
      {
        path: "terms",
        name: "terms",
        component: Terms
      },
      {
        path: "stripe",
        name: "stripe",
        component: StripeElements,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "checkout/:fileId",
        name: "checkout",
        component: Order,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "logout",
        name: "logout",
        component: Logout,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "bionet-tool",
        name: "bionet-tool",
        component: Bionet,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "vegetation-bionet-tool",
        name: "vegetation-bionet-tool",
        component: VegetationBionet,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "admin-aria",
        name: "admin-aria",
        component: AdminAria,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "user-pdf",
        name: "user-aria",
        component: FileUpload,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/login",
        name: "login",
        component: Login
      },
      {
        path: "/register",
        name: "register",
        component: Register
      },
    ]
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage
  },
  {
    path: "/*",
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
